export default __webpack_public_path__ + "static/media/Hortonworks.d490a617.png";